import { render, staticRenderFns } from "./CartSize.vue?vue&type=template&id=6c4e09c8&"
import script from "./CartSize.vue?vue&type=script&lang=js&"
export * from "./CartSize.vue?vue&type=script&lang=js&"
import style0 from "./CartSize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports